export default __webpack_public_path__ + "static/media/tc_meeting_breadcrumb.6eaf80be.svg";